import { call, put, select } from 'redux-saga/effects'
import I from 'immutable'
import Api from 'domain/api'
import * as Actions from './actions'
import * as M from 'domain/env'
import * as Router from 'domain/router'
import { error403, modalIsLoading, pageIsLoading, skeleton } from 'domain/loading'
import { ImportManagerJobDraftRequest } from 'types/job/jobDraftTypes'

export interface ManagerJobDraftsParams {
  status?: string
  sourceType?: string
}

export function* ensureGetManagerJobDrafts(props?: {
  payload?: ManagerJobDraftsParams
  type: string
}) {
  const headers = yield select(M.userToken)
  if (!headers) return

  try {
    yield put({ type: skeleton, payload: true })
    yield put({ type: pageIsLoading, payload: true })
    const { data } = yield call(Api.getManagerJobDrafts, {
      headers: { Authorization: 'Bearer ' + headers },
      params: (props && props.payload) || {}
    })
    yield put({ type: Actions.managerJobDraftsList.success, payload: I.fromJS(data) })
  } catch (err) {
    yield put({ type: Actions.managerJobDraftsList.failure, err })
  } finally {
    yield put({ type: skeleton, payload: false })
    yield put({ type: pageIsLoading, payload: false })
  }
}

export function* ensureGetManagerJobDraft(props?: { payload?: { id?: number }; type: string }) {
  yield put({ type: error403, payload: false })
  const headers = yield select(M.userToken)
  if (!headers) return

  let id = props && props.payload && props.payload.id
  if (!id) {
    const match = yield select(Router.matchRoutes)
    id = match && match.params && match.params.id
  }
  if (!id) return

  try {
    yield put({ type: pageIsLoading, payload: true })
    const {
      data: { data }
    } = yield call(Api.getManagerJobDraft, {
      headers: { Authorization: 'Bearer ' + headers },
      id
    })
    yield put({ type: Actions.managerJobDraftData.success, payload: I.fromJS(data || {}) })
  } catch (err) {
    yield put({ type: Actions.managerJobDraftData.success, payload: I.fromJS({}) })
    const response = err && err.response
    const data = response && response.data
    const statusCode = data && data.statusCode
    if (statusCode === 403 || statusCode === 404) {
      yield put({ type: error403, payload: true })
    }
    yield put({ type: Actions.managerJobDraftData.failure, err })
  } finally {
    yield put({ type: pageIsLoading, payload: false })
  }
}

export function* ensureMarkManagerJobDraftConverted(props: {
  payload: { id: number; jobId: number }
  type: string
}) {
  const headers = yield select(M.userToken)
  if (!headers) return
  if (!props || !props.payload || !props.payload.id || !props.payload.jobId) return

  try {
    const {
      data: { data }
    } = yield call(Api.markManagerJobDraftConverted, {
      headers: { Authorization: 'Bearer ' + headers },
      id: props.payload.id,
      data: { jobId: props.payload.jobId }
    })
    yield put({
      type: Actions.markManagerJobDraftConverted.success,
      payload: I.fromJS(data || {})
    })
  } catch (err) {
    yield put({ type: Actions.markManagerJobDraftConverted.failure, err })
  }
}

export function* ensureImportManagerJobDraft(props: {
  payload: ImportManagerJobDraftRequest
  type: string
}) {
  const headers = yield select(M.userToken)
  if (!headers) return

  try {
    yield put({ type: modalIsLoading, payload: true })
    const {
      data: { data }
    } = yield call(Api.importManagerJobDraft, {
      headers: { Authorization: 'Bearer ' + headers },
      data: props.payload
    })
    yield put({
      type: Actions.importManagerJobDraft.SUCCESS,
      payload: I.fromJS(data || {})
    })
  } catch (err) {
    yield put({ type: Actions.importManagerJobDraft.FAILURE, err })
  } finally {
    yield put({ type: modalIsLoading, payload: false })
  }
}
